import VetroCtaButton from './buttons/CtaButton.vue';
import VetroHeader from './header/Header.vue';
import VetroSidebar from './sidebars/NavSidebar.vue';
import alertComponent from './alert/Alert.vue';

import alertStore from '../store/alert';

const VetroAlert = {
  install(Vue, options) {
    options.store.registerModule('alert', alertStore);

    Vue.component('VetroAlert', alertComponent);

    // eslint-disable-next-line
    Vue.prototype.$alert = {
      success: (args) => {
        options.store.dispatch('alert/successAlert', args);
      },
      failure: (args) => {
        options.store.dispatch('alert/failureAlert', args);
      },
      warn: (args) => {
        options.store.dispatch('alert/warnAlert', args);
      },
      custom: (args) => {
        options.store.dispatch('alert/showAlert', args);
      },
      reset: () => {
        options.store.dispatch('alert/resetAlert');
      },
      setToaster: (args) => {
        options.store.dispatch('alert/setToaster', args);
      },
    };
  },
};

const VetroComponents = {
  VetroCtaButton,
  VetroHeader,
  VetroSidebar,
};

const VetroPlugins = {
  VetroAlert,
};

export default { VetroComponents, VetroPlugins };
